import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

// Use environment variable for the API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AddDispatchedStockOnLoan() {
  const [fromLocation, setFromLocation] = useState("");
  const [organizations, setOrganizations] = useState([]); 
  const [toOrganization, setToOrganization] = useState(""); 
  const [fromLocations, setFromLocations] = useState([]);
  const [createdDate, setCreatedDate] = useState(new Date().toISOString().split("T")[0]); // Default to today
  const [transferItems, setTransferItems] = useState([{ product_id: "", qty: 1 }]);
  const [products, setProducts] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  const [organizationLocations, setOrganizationLocations] = useState([]);
  const [filteredToLocations, setFilteredToLocations] = useState([]);
  const [toLocation, setToLocation] = useState("");
  const [clusters, setClusters] = useState([]);
  const [selectedClusterId, setSelectedClusterId] = useState("");
  const [clusterOrganizations, setClusterOrganizations] = useState([]);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState("");
  const [myClusters, setMyClusters] = useState([]);
  const [allClusters, setAllClusters] = useState([]); 

  useEffect(() => {
    const fetchCurrentUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token missing. Please log in.");
        return;
      }

      try {
        const response = await axios.get(
          `${API_BASE_URL}/users/specific`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const userData = response.data;
        setCurrentUser(userData);

        // Fetch locations and products based on role
        if (userData.role === "Main Admin") {
          fetchAllLocations();
          fetchAllProducts();
        } else if (userData.role === "Company Admin") {
          fetchFilteredLocations(userData);
          fetchFilteredProducts(userData);
        }else if (userData.role === "Farm User") {
          fetchFilteredLocations(userData);
          fetchFilteredProducts(userData);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        toast.error("Failed to fetch user data.");
      }
    };

    fetchCurrentUser();
    fetchAllOrganizations();
    fetchOrganizationsWithLocations();

  }, []);

  useEffect(() => {
    if (toOrganization && organizationLocations.length) {
      const selectedOrg = organizationLocations.find(
        (org) => org._id === toOrganization
      );
      setFilteredToLocations(selectedOrg?.locations || []);
      setToLocation(""); // Reset toLocation when org changes
    }
  }, [toOrganization, organizationLocations]);

  const fetchAllLocations = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${API_BASE_URL}/locations`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (currentUser.role === "Farm User") {
      setFromLocations(response.data.fromLocations || []); // Only assigned locations
    } else {
      setFromLocations(response.data.fromLocations); // Use fetched locations for Admin
    }
  };

  const fetchAllProducts = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${API_BASE_URL}/products`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    setProducts(response.data.products);
  };

  const fetchAllOrganizations = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${API_BASE_URL}/organizations`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    setOrganizations(response.data.organizations);
  };

 const fetchOrganizationsWithLocations = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_BASE_URL}/organizations/organizationLocations`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  setOrganizationLocations(response.data.organizations);
};

  const fetchFilteredLocations = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${API_BASE_URL}/products/filtered-to-from-locations`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (currentUser.role === "Farm User") {
      setFromLocations(response.data.fromLocations || []); // Only assigned locations
    } else {
      setFromLocations(response.data.fromLocations); // Use fetched locations for Admin
    }
  };

  const fetchFilteredProducts = async (userData, locationId) => {
    if (!locationId) {
      // toast.error("Location ID is missing.");
      return;
    }
  
    const token = localStorage.getItem("token");
  
    try {
      const response = await axios.get(
        `${API_BASE_URL}/products/filtered-products-by-location?organization=${userData.organization._id}&locationId=${locationId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      if (response.data.products.length === 0) {
        // No products available for this location
        toast.error("No products available in this location.");
        setProducts([]);  // Clear the previously loaded products
      } else {
        setProducts(response.data.products); // Set products in state
      }
    } catch (error) {
      console.error("Error fetching filtered products:", error);
      toast.error("There are no production batches in this location.");
      setProducts([]); // Clear the products in case of error
    }
  };


  useEffect(() => {
    // If there's only one organization in the selected cluster, auto-select it
    if (clusterOrganizations.length === 1) {
      setToOrganization(clusterOrganizations[0]._id);
    }

    // If there's only one filtered location for the selected organization, auto-select it
    if (filteredToLocations.length === 1) {
      setToLocation(filteredToLocations[0]._id);
    }
  }, [clusterOrganizations, filteredToLocations]);

  
  useEffect(() => {
    // Clear products whenever location changes
    setProducts([]);
    if (currentUser && fromLocation) {
      fetchFilteredProducts(currentUser, fromLocation);
    }
  }, [fromLocation, currentUser]);

  useEffect(() => {
    // Assuming `products` is the state that stores the product data from the API
    console.log(products); // Add this line to check the data
  }, [products]);

  const handleAddTransferItem = () => {
    setTransferItems([...transferItems, { product_id: "", qty: 1 }]);
  };

  const handleRemoveTransferItem = (index) => {
    setTransferItems(transferItems.filter((_, i) => i !== index));
  };

  const handleTransferItemChange = (index, field, value) => {
    const updatedItems = [...transferItems];
  
    if (field === "product_id") {
      const selectedProduct = products.find((p) => p._id === value);
  
      updatedItems[index] = {
        ...updatedItems[index],
        product_id: value,
        unit: selectedProduct?.unit?.unit_name || "", // Store unit name dynamically
      };
    } else {
      updatedItems[index][field] = value;
    }
  
    setTransferItems(updatedItems);
  };

  const handleSubmit = async () => {
    if (!fromLocation || !toOrganization ) {
      toast.error("Please select valid locations.");
      return;
    }

    if (toOrganization === currentUser.organization._id) {
      toast.error("Please select different organization.");
      return;
    }
  
    if (transferItems.some((item) => !item.product_id || item.qty <= 0)) {
      toast.error("Please provide valid product and quantity for all items.");
      return;
    }
  
    // Frontend validation: Check if transfer quantity exceeds available stock
    for (const item of transferItems) {
      const product = products.find((prod) => prod._id === item.product_id);
      
      // Ensure the product exists and contains updated_stock_qty
      if (product) {
        const updatedStockQty = product.updated_stock_qty;
        const isPartialQuantityAllowed = product.partial_qty_allocation;
  
        // Validate transfer quantity
        if (item.qty > updatedStockQty) {
          toast.error(`Stock quantity for ${product.product_name} exceeds available stock of ${updatedStockQty}.`);
          return;
        }

        console.log(product.partial_qty_allocation);

        //ensure addition of whole number for a quantity if partial allocation is false
        if (!isPartialQuantityAllowed && !Number.isInteger(item.qty)) {
          toast.error(`Quantity for ${product.product_name} must be a whole number.`);
          return;
        }

      }
    }
  
    // If validation passes, submit the transfer order
    const payload = {
      cluster_id: selectedClusterId,
      from_location_id: fromLocation,
      to_organization_id: toOrganization,
      to_location_id: toLocation,
      created_date: createdDate,
      dispatchedStockItems: transferItems,
      organization: currentUser?.organization?._id,
      created_by: currentUser._id,
    };
  
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token is missing. Please log in again.");
        return;
      }
  
      const response = await axios.post(`${API_BASE_URL}/dispatchedStockOnLoan/add`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      toast.success(response.data.message || "Outgoing Stock on Loan created successfully!");
      console.log("Transfer order created: ", response.data.transferOrder);

      setFromLocation("");
      setToOrganization("");
      setTransferItems([{ product_id: "", qty: 0 }]);
      setProducts([]);
      setToLocation("");
      
    } catch (error) {
      console.error("Error creating outgoing stock on loan:", error);
      toast.error("Failed to create outgoing stock on loan. Please try again.");
    }
  };
  
  const ProductOption = ({ data, innerRef, innerProps, isFocused, isSelected, index }) => {
    const currentCategory = data.category;
  
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={`flex items-center p-2 ${isFocused ? "bg-gray-200" : ""} ${isSelected ? "bg-blue-500 text-white" : ""}`}
      >
        {data.product_image && (
          <img
            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${data.product_image}`}
            alt={data.product_name}
            className="w-10 h-10 object-cover mr-2"
          />
        )}
        <span>{data.product_name}</span>
  
        {/* Add a divider before a new category */}
        {index !== 0 && currentCategory !== data.category && (
          <div className="border-t my-2"></div>
        )}
      </div>
    );
  };

  const handleQuantityChange = (productId, newQty) => {
    setTransferItems((prevItems) =>
      prevItems.map((item) => {
        if (item.product_id === productId) {
          const product = products.find((prod) => prod._id === productId);
  
          if (!product) return item; // Skip if product not found
  
          const isPartialQuantityAllowed = product.partial_qty_allocation;
  
          // Prevent decimals if partial allocation is false
          if (!isPartialQuantityAllowed && !Number.isInteger(newQty)) {
            toast.error(`Quantity for ${product.product_name} must be a whole number.`);
            return item; // Keep previous value
          }
  
          return { ...item, qty: newQty };
        }
        return item;
      })
    );
  };
  
   useEffect(() => {
    const token = localStorage.getItem("token");

    axios
      .get(`${API_BASE_URL}/clusters/myClusters`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setMyClusters(res.data);
      })
      .catch((err) => {
        console.error("Error fetching myClusters", err);
        toast.error("Failed to fetch my clusters.");
      });

    axios
      .get(`${API_BASE_URL}/clusters`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setAllClusters(res.data);
      })
      .catch((err) => {
        console.error("Error fetching clusters", err);
        toast.error("Failed to fetch all clusters.");
      });
  }, []);

  const handleClusterChange = (e) => {
    const clusterId = e.target.value;
    setSelectedClusterId(clusterId);
    setSelectedOrganizationId("");
    setToOrganization("");
    setToLocation("");

    const selectedCluster = allClusters.find((c) => c._id === clusterId);

    if (selectedCluster && selectedCluster.organizations) {
      // Filter out current user's org
      const orgs = selectedCluster.organizations.filter(
        (org) => org._id !== currentUser.organization._id
      );
      setClusterOrganizations(orgs);
    } else {
      setClusterOrganizations([]);
    }
  };

  const customProductSelect = (productOptions, index) => {
    const selectedProductIds = transferItems
      .filter((_, i) => i !== index)
      .map((item) => item.product_id);
  
    const filteredOptions = productOptions.filter(
      (product) => !selectedProductIds.includes(product._id)
    );
  
    return (
      <Select
        options={filteredOptions}
        getOptionLabel={(e) => e.product_name}
        getOptionValue={(e) => e._id}
        components={{
          Option: (props) => <ProductOption {...props} index={index} />,
        }}
        onChange={(selectedOption) =>
          handleTransferItemChange(index, "product_id", selectedOption?._id)
        }
        placeholder="Search and select product"
        className="w-full"
        value={transferItems[index]?.product_id ? filteredOptions.find((option) => option._id === transferItems[index].product_id) : null}
      />
    );
  };

  return (
    <div className="container mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6 mt-4">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Add Outgoing Stock On Loan</h2>
        <div className="grid grid-cols-1 gap-8">
          {/* From Location */}
          <div className="mb-1">
          <label className="block text-gray-700 mb-2">From Location</label>
          <select
            className="w-full p-3 border rounded-lg"
            value={fromLocation}
            onChange={(e) => setFromLocation(e.target.value)}
          >
            <option value="" disabled>--Select From Location--</option>
            {fromLocations
              .filter((location) => location._id !== toOrganization) // Exclude selected "To Location"
              .map((location) => (
                <option key={location._id} value={location._id}>
                  {location.location_name}
                </option>
              ))}
          </select>
       <div className="mt-4">
        {/* Select Cluster */}
        <div>
          <label className="block mb-1 text-gray-700">Select Cluster</label>
          <select
            value={selectedClusterId}
            onChange={handleClusterChange}
            className="w-full p-3 border rounded-lg"
          >
            <option value="">-- Select Cluster --</option>
            {myClusters.map((cluster) => (
              <option key={cluster._id} value={cluster._id}>
                {cluster.cluster_name}
              </option>
            ))}
          </select>
        </div>
        </div>
      </div>
        {/* To Organization & Location Group */}
        <div className="mb-4">
          <div className="grid grid-cols-2 gap-4">
             {/* To Organization */}
              <div>
                <label className="block text-gray-700 mb-2">To Organization</label>
                <select
                  className="w-full p-3 border rounded-lg"
                  value={toOrganization}
                  onChange={(e) => setToOrganization(e.target.value)}
                  disabled={!selectedClusterId}
                >
                  <option value="" disabled>
                    {selectedClusterId ? "Select To Organization" : "No Cluster Available"}
                  </option>
                  {clusterOrganizations.map((org) => (
                    <option key={org._id} value={org._id}>
                      {org.organization_name}
                    </option>
                  ))}
                </select>
              </div>

            {/* To Location */}
            <div>
              <label className="block text-gray-700 mb-2">To Location</label>
              <select
                className="w-full p-3 border rounded-lg"
                value={toLocation}
                onChange={(e) => setToLocation(e.target.value)}
                disabled={!filteredToLocations.length}
              >
                <option value="" disabled>
                  {filteredToLocations.length
                    ? "Select To Location"
                    : "No Locations Available"}
                </option>
                {filteredToLocations.map((loc) => (
                  <option key={loc._id} value={loc._id}>
                    {loc.location_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-700 mb-4">Stock Items</h3>
          {/* Column Headers */}
          <div className="grid grid-cols-2 gap-8 mb-1 block text-gray-700 ">
            <div>Product</div>
            <div className="grid grid-cols-2 gap-8 mb-2 block text-gray-700">
              <div className="grid grid-cols-2 gap-8 mb-2 block text-gray-700">
                <div>Quantity</div>
                <div>Unit</div>
              </div>
              <div>Action</div>
            </div>  
          </div>
          {/* Stock Items Rows */}
          {transferItems.map((item, index) => (
            <div key={index} className="grid grid-cols-2 gap-8 mb-4">
              {/* Product */}
              <div className="w-full">
                {customProductSelect(products, index)}
              </div>
              <div className="grid grid-cols-2 gap-8">
                <div className="grid grid-cols-2 gap-8">
                  {/* Quantity Input */}
                  <div className="w-full">
                  <input
                    type="number"
                    placeholder="Qty"
                    className="p-3 border rounded-lg w-full"
                    value={item.qty}
                    onChange={(e) => handleQuantityChange(item.product_id, Number(e.target.value))}
                    min="0"
                    step={products.find((p) => p._id === item.product_id)?.partial_qty_allocation ? "0.25" : "1"} 
                  />
                  </div>
                  {/* Unit Display */}
                  <div className="w-full flex items-center">
                    <span className="text-gray-700">{item.unit || "-"}</span>
                  </div>
                </div>     
              {/* Remove Button */}
              <div className="w-full flex items-center">
                <button
                  className="bg-red-500 text-white px-4 py-2 rounded-lg"
                  onClick={() => handleRemoveTransferItem(index)}
                >
                  Remove
                </button>
              </div>
            </div>
            </div>
          ))}

          {/* Add Item Button */}
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-lg"
            onClick={handleAddTransferItem}
            >
              Add Item
          </button>
        </div>
        <div className="text-right">
          <button
            onClick={handleSubmit}
            className="bg-blue-700 text-white py-3 px-6 rounded-lg hover:bg-blue-600"
          >
            Submit Outgoing Stock On Loan
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddDispatchedStockOnLoan;
